import { combineUint48LE } from '@star-snake/shared'

export class BinaryReaderV4 {
  private readonly view: DataView
  private readonly textDecoder = new TextDecoder()
  offset = 0

  constructor(buffer: ArrayBuffer) {
    this.view = new DataView(buffer)
  }

  readUint8(): number {
    const value = this.view.getUint8(this.offset)
    this.offset += 1
    return value
  }

  readUint16(): number {
    const value = this.view.getUint16(this.offset, true)
    this.offset += 2
    return value
  }

  readUint32(): number {
    const value = this.view.getUint32(this.offset, true)
    this.offset += 4
    return value
  }

  readUint48(): number {
    const lo32 = this.readUint32()
    const hi16 = this.readUint16()
    return combineUint48LE(lo32, hi16)
  }

  readInt16(): number {
    const value = this.view.getInt16(this.offset, true)
    this.offset += 2
    return value
  }

  readFloat32(): number {
    const value = this.view.getFloat32(this.offset, true)
    this.offset += 4
    return value
  }

  readBoolean(): boolean {
    return this.readUint8() !== 0
  }

  readString(): string {
    const byteLength = this.readUint16()
    const start = this.offset
    const end = start + byteLength
    const value = this.textDecoder.decode(new Uint8Array(this.view.buffer, start, byteLength))
    this.offset = end
    return value
  }

  remaining(): number {
    return this.view.byteLength - this.offset
  }
}
